module.exports = __webpack_public_path__ + "img/category.f8b315a8.svg";